import React from 'react'
import Layout from '../layout/Layout'

export default function IpoModel() {
    return (
        <Layout>
            <section id="user-portfolio" class="py-4">
                <div class="container">
                    <div class="row g-3 align-items-center mb-5">
                        <div class="col-md-12">
                            <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <h4 class="mb-0 fw-bold">IPO</h4>
                                <small class="fw-normal text-muted">We recommend which IPOs you should subscribe to and which you should avoid.</small>
                            </div>

                            <div class="row g-3 align-items-center">
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Allocated Fund</small>
                                    <h4 class="mb-0">2,00,000</h4>
                                </div>
                                {/* <!-- <div class="col-md-3 col-6">
                                                    <small class="text-muted d-block">Available Funds</small>
                                                    <h4 class="mb-0">25,000</h4>
                                                </div> -->
                                                <!-- <div class="col-md-3 col-6">
                                                    <small class="text-muted d-block">Current Value</small>
                                                    <h4 class="mb-0">1,80,000</h4>
                                                </div>
                                                <div class="col-md-3 col-6">
                                                    <small class="text-muted d-block">Overall P&L</small>
                                                    <div class="d-flex align-items-baseline gap-2">
                                                        <h4 class="text-success mb-0">+5,000</h4>
                                                        <small class="text-success">(+7.5%)</small>
                                                    </div>
                                                </div>
                                                <div class="col-md-3 col-6">
                                                    <small class="text-muted d-block">Day's P&L</small>
                                                    <div class="d-flex align-items-baseline gap-2">
                                                        <h4 class="text-success mb-0">+500</h4>
                                                        <small class="text-success">(+0.75%)</small>
                                                    </div>
                                                </div> --> */}
                            </div>
                            {/* <!-- <a href="./mf.php" class="btn btn-dark mt-4"><i class="fa fa-unlock"></i> View Full Portfolio</a> --> */}

                        </div>
                        {/* <!-- Pie chart --> */}
                        <div class="col-md-2 col-6">
                            <div class="d-flex justify-content-center">
                                {/* <!-- <div class="ratio ratio-1x1"> -->
                                                    <canvas id="portfolioPieChart"></canvas>
                                                    <!-- </div> --> */}
                            </div>
                        </div>
                        {/* <!-- Legend --> */}
                        <div class="col-md-4 col-6">
                            <div id="portfolioPieLegend" class="pie-legend ms-md-2 my-3 mt-md-0"></div>
                        </div>
                    </div>

                    <ul class="nav nav-underline border-bottom mb-3 d-none" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Open</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link " id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">Closed</button>
                        </li>
                    </ul>

                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                            <div class="d-flex align-items-baseline">
                                <h5 class="mb-1 fw-bold">IPO Recommendations</h5>
                                <small class="text-muted ms-3">As on 22 Dec, 2025</small>
                            </div>

                            <p>Check the recommendations before subscribing to any IPO.</p>

                            {/* <!-- Table header (desktop) --> */}
                            <div class="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                                <div class="row g-3">
                                    <div class="col-md-3">
                                        <span>IPO</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <span>Min. Investment</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <span>Dates</span>
                                    </div>
                                    <div class="col-md-3 text-end">
                                        <span>EP Recommendation</span>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Rows -->
                                            <?php foreach ($rows as $index => $row): ?> */}
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                                <div class="row g-3 align-items-center">
                                    <div class="col-md-3 col-4">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="">
                                                <i class="fa fa-circle fa-2xs" style={{ "color": "black" }}></i> <span>symbol</span>
                                                <small class="d-block d-none">
                                                    <small class="text-muted d-block">
                                                        <i class="fa fa-briefcase"></i> recomQty Shares
                                                    </small>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-8">
                                        <div class="text-end">
                                            <small><small class="d-block d-md-none text-muted">SIP / Mo.</small></small>
                                            <span class="">invested</span>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        <div class="text-start text-md-end">
                                            <small><small class="d-block d-md-none text-muted">Dates</small></small>
                                            <small>19 Dec, 2025 - 24 Dec, 2025</small>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-6">
                                        <div class="text-end">
                                            <small class="d-block"><small class="d-block d-md-none text-muted">EP Recommendation</small></small>
                                            <small class="bg-success bg-opacity-10 px-2 py-1 rounded-3">Subscribe</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <?php endforeach; ?> */}
                        </div>
                        <div class="tab-pane fade " id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="d-flex align-items-baseline">
                                        <h5 class="my-3 fw-bold">Closed Recommendations</h5>
                                        <small class="text-muted">As on 22 Dec, 2025</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="d-flex justify-content-md-end justify-content-between gap-3 mb-3">
                                        <div class="me-4 d-none">
                                            <small class="text-muted mb-1 d-block">Select Month</small>
                                            <select class="form-select" aria-label="Default select example">
                                                <option selected>- Select -</option>
                                                <option value="1">Nov 2025</option>
                                                <option value="2">Oct 2025</option>
                                                <option value="3">Sep 2025</option>
                                            </select>
                                        </div>
                                        <div class="">
                                            <small class="text-muted mb-1 d-block">Total Booked P&L</small>
                                            <h3 class="fw-bold text-success">+50,725</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Table header (desktop) --> */}
                            <div class="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                                <div class="row g-3">
                                    <div class="col-md-2">
                                        <span>Scrip</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Dates</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Invested & Booked</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Entry & Exit</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Range</span>
                                    </div>
                                    <div class="col-md-2 text-end">
                                        <span>Booked P&L</span>
                                    </div>
                                </div>
                            </div>

                            {/* <!-- Rows -->
                                            <?php foreach ($rows as $index => $row): ?> */}
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                                <div class="row g-3 align-items-center">
                                    <div class="col-md-2 col-6">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="">
                                                <i class="fa fa-circle fa-2xs" style={{ "color": "black" }}></i> symbol
                                                <small class="d-block">
                                                    <small class="text-muted d-block">
                                                        <i class="fa fa-briefcase"></i> recomQty
                                                    </small>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-end">
                                            <span class="d-block"><small><small class="text-muted">Entry</small></small> 10 Dec, 2025</span>
                                            <span class="d-block"><small><small class="text-muted">Exit</small></small> 17 Dec, 2025</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-start text-md-end">
                                            <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                            <span class="">invested</span>
                                            <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Booked</small></small>
                                            <span class="<?= $row['pnlClass'] ?>">currentValue</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-end">
                                            <small><small class="d-block d-md-none text-muted">Entry</small></small>
                                            <span>avgPrice</span>
                                            <small class="d-block"><small class="d-block d-md-none text-muted">Exit</small></small>
                                            <span class="<?= $row['pnlClass'] ?> d-block">ltp</span>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-start text-md-end">
                                            <small><small class="d-block d-md-none text-muted">Range</small></small>
                                            avg - ltp
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-6">
                                        <div class="text-end">
                                            <small><small class="d-block d-md-none text-muted">Booked P&L</small></small>
                                            <span class="<?= $row['pnlClass'] ?>">pnl<br class="d-none d-md-block" />
                                                <small><small class="">(+8.75%) pnlIcon</small></small>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/* <?php endforeach; ?> */}
                        </div>
                    </div>

                </div>

                {/* <!-- Modal --> */}
                <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                    <div class="modal-dialog modal-sm">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="exampleModalLabel">Edit Average Price</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div class="d-flex justify-content-between gap-3">
                                    <div>
                                        <small>Scrip</small>
                                        <p class="fw-bold">SBIN</p>
                                    </div>
                                    <div>
                                        <small>Current Avg. Price</small>
                                        <p class="fw-bold">2498.85</p>
                                    </div>
                                </div>
                                <div class="form-floating">
                                    <input type="number" class="form-control fw-bold" id="floatingInput" placeholder="Enter New Avg. Price" />
                                    <label for="floatingInput">Enter New Avg. Price</label>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Modal --> */}

            </section>
        </Layout>
    )
}
